/**
 * TB-App API – Generated by orval 🍺
 * Do not edit manually.
 */

export type LabReportResistanceDtoResistanceName =
  (typeof LabReportResistanceDtoResistanceName)[keyof typeof LabReportResistanceDtoResistanceName];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const LabReportResistanceDtoResistanceName = {
  ISONIAZID: 'ISONIAZID',
  RIFAMPICIN: 'RIFAMPICIN',
  ETHAMBUTOL: 'ETHAMBUTOL',
  PYRAZINAMID: 'PYRAZINAMID',
} as const;
